import React, { useState } from 'react';
import { X } from '@phosphor-icons/react';
import { PropertyLightbox } from './PropertyHero';
import { PropertyDetails, PropertyEconomics, LocationSection, SectionHeading } from './ProjectOverviewSections';
import { countryName } from '../../lib/countries';

export const PropertyDetailSheet = ({ asset, project, economics, onClose, onViewFinancials }) => {
  const [lightbox, setLightbox] = useState(null);
  if (!asset) return null;
  const pics = asset.image_urls || [];

  return (
    <div className="fixed inset-0 z-[90] bg-[rgb(var(--background))] overflow-y-auto" data-testid="property-detail-sheet">
      <div className="sticky top-0 z-10 bg-[rgb(var(--background))]/95 backdrop-blur-md border-b border-black/[0.05]">
        <div className="container mx-auto px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.18em] text-foreground-muted">Property</p>
            <h2 className="text-lg md:text-xl font-heading font-semibold">{asset.name}</h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-black/5" data-testid="property-sheet-close">
            <X size={22} />
          </button>
        </div>
      </div>

      <div className="container mx-auto px-6 md:px-12 lg:px-20 py-8 space-y-14 max-w-5xl">
        {pics.length > 0 && (
          <div className="-mx-6 md:mx-0">
            <div
              className="flex gap-3 overflow-x-auto snap-x snap-mandatory scrollbar-hide px-6 md:px-0"
              data-testid="property-sheet-gallery"
            >
              {pics.map((url, i) => (
                <button
                  key={i}
                  onClick={() => setLightbox(i)}
                  className="snap-start flex-shrink-0 w-[82%] sm:w-[60%] md:w-[48%] h-[230px] md:h-[320px] rounded-2xl overflow-hidden bg-black/[0.05]"
                  data-testid={`property-sheet-image-${i}`}
                >
                  <img src={url} alt={`${asset.name} ${i + 1}`} className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
            {pics.length > 1 && (
              <p className="px-6 md:px-0 mt-3 text-xs text-foreground-muted">
                Scroll for all {pics.length} photos · tap any photo to enlarge
              </p>
            )}
          </div>
        )}

        {asset.description && (
          <section>
            <SectionHeading>Property overview</SectionHeading>
            <p className="text-sm text-foreground-muted leading-relaxed whitespace-pre-line">{asset.description}</p>
          </section>
        )}

        <PropertyDetails asset={asset} project={project} />

        <PropertyEconomics economics={economics} onViewFinancials={onViewFinancials} />

        <LocationSection asset={asset} project={project} />

      </div>

      {lightbox !== null && (
        <PropertyLightbox images={pics} startIndex={lightbox} title={asset.name} onClose={() => setLightbox(null)} />
      )}
    </div>
  );
};

export default PropertyDetailSheet;
